module.exports = __webpack_public_path__ + "static/media/img004.3c49736d.jpg";